import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "../errorPopup/errorPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function CallEndedNotificationPopup({
  onClose,
  by,
}: IPopupWithoutProps & { by: string }) {
  return (
    <article className={popupStyles.popup}>
      <h2 className={popupStyles.popup__title}>{t("CALL_ENDED_NOTIFICATION_POPUP_TITLE", { by: by })}</h2>
      <img
        src={doctor}
         alt={t("CALL_ENDED_NOTIFICATION_POPUP_IMAGE_ALT")}
        className={popupStyles.popup__img}
      />
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
         {t("CALL_ENDED_NOTIFICATION_POPUP_BUTTON")}
      </button>
    </article>
  );
}

export default CallEndedNotificationPopup;
